import React, { Component } from "react";
import { compose } from "recompose";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import SubAgentTreeItem from "./SubAgentTreeItem";
import _ from "lodash";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
  },
});

class SubAgentTree extends Component {
  shouldComponentUpdate({ FavoriteReports }) {
    return !_.isEqual(FavoriteReports, this.props.FavoriteReports);
  }
  render() {
    const { SubAgents, selectedSubAgent, selectSubAgent } = this.props;
    return (
      <React.Fragment>
        {SubAgents.map((subAgent) => (
          <SubAgentTreeItem
            key={subAgent.IdAgent}
            {...{
              subAgent,
              selectedSubAgent,
              selectSubAgent,
            }}
          />
        ))}
      </React.Fragment>
    );
  }
}

SubAgentTree.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  SubAgents: PropTypes.array.isRequired,
  selectSubAgent: PropTypes.func.isRequired,
  selectedSubAgent: PropTypes.string.isRequired,
};

export default compose(
  withStyles(styles, {
    name: "SubAgentTree",
    withTheme: true,
  }),
)(SubAgentTree);
